const questionSetConfig = require('./questionsets-config');

module.exports = questionSetConfig;
